import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import './PurchaseCredits.css';
import { FormattedMessage } from 'react-intl';
import { Result } from 'antd';
import CreditPackage from './CreditPackage';
import { setChosenCreditPackage } from '../../../state/ui/purchase/purchaseCreditsUiActions';
import { tokenPackageShape, createPackagesHash } from './purchase-util';
import PurchaseResult from './PurchaseResult';
import { selectPurchasePackageRequest } from '../../../state/ui/purchase/purchaseCreditsUiReducer';


/**
 * Displays a list of purchasable Credit Token Packages.
 * @param {object} props React props
 * @param {array} props.creditPackages An array of Token Credit Packages
 * @param {bool} props.isLoading True if packages are loading.
 */
export default function CreditPackages({ creditPackages, disablePackageSelection }) {
  // Redux State
  const purchaseRequest = useSelector(selectPurchasePackageRequest);
  const dispatch = useDispatch();
  const chooseCreditPackage = useCallback((packageCode) => {
    dispatch(setChosenCreditPackage(packageCode));
  }, [dispatch]);

  // If the loaded packages change, then we need to reset the component the component state.
  const creditPackagesHash = createPackagesHash(creditPackages);
  useEffect(() => {
    chooseCreditPackage();
  }, [creditPackagesHash, chooseCreditPackage]);


  // Render - Package purchase has started / finished
  if (purchaseRequest) return <PurchaseResult purchaseRequest={purchaseRequest} />;

  // Render - No packages available.
  if (!creditPackages || creditPackages.length <= 0) {
    return (
      <Result
        status="404"
        title={<FormattedMessage id="noPackages" />}
        subTitle={<FormattedMessage id="noPackagesDesc" />}
      />
    );
  }

  // Render - Default, show all the available packages.
  return (
    <>
      <div className="purchase-credits-packages via-centre">
        { creditPackages.map(creditPackage => (
          <CreditPackage
            key={creditPackage.code}
            creditPackage={creditPackage}
            onSelect={p => chooseCreditPackage(p.code)}
            onCancel={() => chooseCreditPackage()}
            disablePackageSelection={disablePackageSelection}
          />
        ))}
      </div>
    </>
  );
}

CreditPackages.propTypes = {
  creditPackages: PropTypes.arrayOf(tokenPackageShape),
  disablePackageSelection: PropTypes.bool,
};

CreditPackages.defaultProps = {
  creditPackages: null,
  disablePackageSelection: false,
};
